import { useState, useEffect, useCallback } from 'react';

function useScrollTrigger() {
  //N/B this hook works as the useScrollTriggerAnim at 80, used for the menu appearance and disapperance
  const [showMenu, setShowMenu] = useState(false);

  const handleScroll = useCallback(() => {
    setShowMenu(window.scrollY > 80);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  return showMenu;
}

export default useScrollTrigger;
